import { formatDate } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { messages } from 'src/app/resources/messages';
import { CommonService } from 'src/app/services/common.service';
import { ExportService } from 'src/app/services/export.service';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  selector: 'common-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent {

  @Input() export: boolean = false;
  @Input() fetchExportToExcel!: () => Observable<any>;
  @Input() fetchBlueBalloonLogsGridDataExportToExcel!: () => Observable<any>;
  @Input() fetchBlueBalloonLogsPinsListExportToExcel!: (args: any) => Observable<any>;
  @Input() userJourneyName!: string;
  @Input() exportType: any;
  @ViewChild('modalReference') modalRef: ElementRef<any> | undefined;
  @ViewChild('pinsTextAreaReference') pinsTextAreaRef!: ElementRef<any>;
  @ViewChild('exportRadioGroup') exportRadioGroupRef!: ElementRef<any>;
  @ViewChild('pinsFromDataGridReference') pinsFromDataGridReference!: ElementRef<any>;
  @ViewChild("exportDropDown") exportDropDown: ElementRef<any> | undefined;

  public msg = messages;
  public pinsTextArea = false;
  public pinsTextAreaStatus = "valid";
  public radioSelectionErrorStatus = false;
  public blueBalloonRadioVal!: string;

  constructor(private exportService: ExportService, private loggingService: LoggingService,
    private commonService: CommonService) { }

  setSelectedExport($event: any)
   {
    this.blueBalloonRadioVal = '';
    if ($event.detail?.optionSelected.value == "Export" ||$event.detail?.optionSelected.value == "Export to excel") 
    {
      this.exportToExcel();
    }
     else if ($event.detail?.optionSelected.value == "Export notes log")
     {
      this.loggingService.logCustomEvent("Export notes log");
      this.modalRef?.nativeElement.openModal();
      if (this.exportRadioGroupRef?.nativeElement.reset()) 
      {
        this.pinsTextAreaStatus = "valid";
        this.pinsTextArea = false;
        this.pinsFromDataGridReference?.nativeElement?.setSelection(true);
      }
    }
    this.exportDropDown?.nativeElement.resetSelectMenu();
  }

  public exportToExcel(): void {
    this.loggingService.logCustomEvent("Export");
    let counter: number = this.exportService.callExportToExcelData();
    let subscription = this.exportService.exportToExcelData.subscribe(data => {
      subscription.unsubscribe();
      this.beginExport(data, counter);
    });
  }

  closeExportModal() {
    this.loggingService.logCustomEvent("Cancel Export Modal");
    this.modalRef?.nativeElement.closeModal();
  }

  getSelectedBBRadio($event: any) {
    this.radioSelectionErrorStatus = false;
    this.pinsTextAreaStatus = "";
    this.blueBalloonRadioVal = $event.detail.value;

    if (this.blueBalloonRadioVal == "from_list")
      this.pinsTextArea = true;
    else
      this.pinsTextArea = false;
  }

  exportBlueBalloon() {
    if (this.blueBalloonRadioVal == "data_grid") {
      let counter: number = this.exportService.callBlueBalloonLogsGridDataExportToExcelData();
      let subscription = this.exportService.blueBalloonLogsGridDataExportToExcelData.subscribe(data => {
        subscription.unsubscribe();
        this.beginExport(data, counter);
      })
    } else if (this.blueBalloonRadioVal == "from_list") {
      const pinsList = this.pinsTextAreaRef?.nativeElement.value.trim();
      if (pinsList != "") {
        this.pinsTextAreaStatus = "valid";
        const dataVal = { tfPins: pinsList.split("\n") };
        this.isPinValid(dataVal);
      } else {
        this.pinsTextAreaStatus = "invalid";
      }
    } else {
      this.radioSelectionErrorStatus = true;
    }
  }

  downloadFile(data: any) {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    let currentDate = new Date();
    let toDefaultDate = formatDate(currentDate, 'ddMMMyyyy_hhmmssa', 'en-US');

    let link = document.createElement('a');
    link.download = this.userJourneyName + "_" + toDefaultDate;
    let blob = new Blob([data], { type: contentType });
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
    this.loggingService.logCustomEvent("Export succeeded");
  }

  checkBBPin(pins: any){
    const specialChars = /[^a-zA-Z0-9\s]/;
    let status = pins.map((pin: any)=>{
       return specialChars.test(pin);  
    });
    if (status.includes(true)) {
      return 'invalidBBPin'
    } else {
      return 'validBBPin'
    }
  }

  clearPins() {
    this.loggingService.logCustomEvent("Clear Pins");
    this.pinsTextAreaRef.nativeElement.value = '';
    this.pinsTextAreaStatus = "valid";
  }

  private isPinValid(dataVal:any){
    if(dataVal?.tfPins.length <= 500){
      let pinStatus = this.checkBBPin(dataVal?.tfPins);
      if(pinStatus == 'invalidBBPin'){
        this.pinsTextAreaStatus = "invalidPin";
      }else{
        let counter: number = this.exportService.callBalloonLogsPinsListExportToExcelData(dataVal);
        let subscription = this.exportService.blueBalloonLogsPinsListExportToExcelData.subscribe(data => {
          subscription.unsubscribe();
          this.beginExport(data, counter);
        })
      }         
    }else
      this.pinsTextAreaStatus = "maxlimit";
  }

  private beginExport(data: any, counter: number) {
    if (data.counter == counter) {
      let exportData = data.data;
      if (exportData.type == 'application/json')
      {
        this.loggingService.logCustomEvent(this.msg.export.exportNoRecord);
        const infoMsgObj = { msg: this.msg.export.exportNoRecord, type: "info" };
        this.commonService.changeMessage(infoMsgObj);
      }
      else
        this.downloadFile(exportData);
    }
  }

  ngOnDestroy() {
    this.exportType = [];
  }
}
